// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"742":"3a974fab","2113":"3a974fab","2918":"3a974fab","4279":"3a974fab","8670":"3a974fab","8942":"3a974fab","9742":"3a974fab"}[chunkId] + ".chunk.css";
};